import script from "./FinanceSetupLayout.vue?vue&type=script&setup=true&lang=js"
export * from "./FinanceSetupLayout.vue?vue&type=script&setup=true&lang=js"

import "./FinanceSetupLayout.vue?vue&type=style&index=0&id=2d89233b&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2d89233b"]])

export default __exports__